import { IReferential } from './IReferential';

export interface GetAllLegalDocumentsPayload {
  fleetLegalDocumentTypeId: number | null;
  appTypeId: number | null;
  page: number;
  pageSize: number;
}

export interface LegalDocumentType {
  id: number;
  version: string | null;
  fleetLegalDocumentTypeId: number;
  fileName: string;
  originalFileName: string;
  uploadDate: string;
  fleetLegalDocumentType: LegalAttachmentType;
  appType: IReferential | null;
}

export interface LegalAttachmentType {
  id: number;
  code: string;
  name: string;
  displayName: string;
  isActive: boolean;
  type: string | null;
  account: string | null;
  isoCode: null;
}

export interface CreateDocumentsPayload {
  fleetLegalDocumentTypeId: number;
  appTypeId: number;
  version: string;
  fileName: string;
  originalFileName: string;
  file: File;
}

export interface LegalDocumentsResponse {
  legalDocuments: LegalDocumentType[];
  total: number;
}

export interface AcceptLatestsConnectLegalDocumentsPayload {
  userId: string;
  acceptedConnectTermsAndConditions: boolean;
  acceptedConnectPrivacyPolicy: boolean;
}

export enum LegalDocumentEnum {
  TERMS_AND_CONDITIONS = 1,
  PRIVACY_POLICY = 2,
}
